import { useDispatch, useSelector } from 'react-redux';
import { hasLineItemsInOrderSelected } from '../../../../../../selectors/tools';
import { selectSearchPageLoading } from '../../../../../../selectors/searchPage';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import React from 'react';
import { processRevolveOrderItemsCancelFlow } from '../../../../../../actions/tools/DecisionTree/RevolveActions';

const DTRevolveSelectOrderForCancelNode = () => {
  const dispatch = useDispatch();
  const hasLineItemsSelected = useSelector(hasLineItemsInOrderSelected);
  const isLoading = useSelector(selectSearchPageLoading);

  const handleNextButtonClick = async () => {
    await dispatch(processRevolveOrderItemsCancelFlow());
  };

  return (
    <DTOrderSearchView
      onNextButtonClick={handleNextButtonClick}
      isNextButtonActive={hasLineItemsSelected && !isLoading}
    />
  );
};

export default DTRevolveSelectOrderForCancelNode;
